class GtcStoreSelect extends HTMLElement {
  static get observedAttributes() { return ['open']; }

  get isOpen() {
      return this.hasAttribute("open");
  }
  set isOpen(value) {
      if (value) {
          this.setAttribute("open", "");
          document.addEventListener('click', this.OnOutsideClick);
      } else {
          this.removeAttribute("open");
          document.removeEventListener('click', this.OnOutsideClick);
      }
  }

  constructor() {
      super();
      // Add your custom element initialization code here
      this.isInit = false;
      this.dom = {
          container: this.querySelector('.store-language-container'),
          nav: this.querySelector('nav'),
      };
      this.OnOutsideClick = this.OnOutsideClick.bind(this);
  }

  connectedCallback() {
      // Add your custom element connected callback code here
      if (!gtcStoreSelect || !gtcStoreSelect.length) {
          this.remove();
      }
      this.SetEventListeners();
  }

  disconnectedCallback() {
      // Add your custom element disconnected callback code here
      this.removeEventListeners();
  }

  attributeChangedCallback(name, oldValue, newValue) {
      // Add your custom element attribute changed callback code here
  }

  SetEventListeners() {
      this.addEventListener('click', this.OnClick.bind(this));
  }

  OnClick(event) {
      if (event.target === this.dom.nav && event.target === event.target.closest(this.dom.nav)) return;

      this.isOpen = !this.isOpen;

      if (this.isOpen && !this.isInit) {
          this.PopulateList();
          this.isInit = true;
      }
  }

  PopulateList() {
      const lang = navigator.language || navigator.userLanguage;
      const regionNamesByBrowser = new Intl.DisplayNames([lang], { type: 'region' });
      const list = document.createElement('ul');

      gtcStoreSelect.forEach((store) => {
          const listItem = document.createElement('li');
          const flagImage = document.createElement('img');
          const anchor = document.createElement('a');
          const span = document.createElement('span');
          flagImage.src = `https://flagcdn.com/${ store.country_code }.svg`;

          if (store.default) {
              anchor.classList.add('active');
          }

          anchor.href = store.store_url;
          span.innerText = store.overwrite_language ? regionNamesByBrowser.of(store.country_code.toUpperCase()) ?? store.store_language : store.store_language;

          anchor.appendChild(flagImage);
          anchor.appendChild(span);

          listItem.appendChild(anchor);
          list.appendChild(listItem);

      });

      this.dom.nav.appendChild(list);
  }

  OnOutsideClick(event) {
      if (!this.contains(event.target)) {
          this.isOpen = false;
      }
  }
}

customElements.define('gtc-store-select', GtcStoreSelect);